<template>
  <!-- 增加修改 -->
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="手机号" prop="phoneNumber">
        <a-input
          v-model="form.phoneNumber"
          placeholder="请输入"
          :disabled="isEdit ? true : false"
          @change="handleChangePhone"
          :maxLength="11"
        />
      </a-form-model-item>
      <template v-if="(role == 'YSY00' && isShow) || isShow">
        <a-form-model-item label="用户姓名" prop="nickName">
          <a-input v-model="form.nickName" placeholder="请输入" :maxLength="30" :disabled="isFage ? true : false" />
        </a-form-model-item>
        <template v-if="!isFage">
          <a-form-model-item label="头像" prop="avatar">
            <file-upload
              type="image"
              :file="form.avatar"
              @input="getImg($event, 'avatar')"
              :count="1"
              autoCropHeight="200"
              autoCropWidth="200"
            ></file-upload>
          </a-form-model-item>
          <a-form-model-item label="生日" prop="birthday">
            <a-date-picker v-model="form.birthday" format="YYYY-MM-DD" @change="handleChange" />
          </a-form-model-item>
          <a-form-model-item label="身份证" prop="cardImgs">
            <file-upload
              type="image"
              :defaultList="form.cardImgs"
              :file="form.cardImgs"
              @input="getImg($event, 'cardImgs')"
              :count="2"
              autoCropHeight="200"
              autoCropWidth="200"
            ></file-upload>
          </a-form-model-item>
          <a-form-model-item label="区域" prop="regionId" v-if="userType == 0 || userType == 1">
            <div class="form_select">
              <a-select
                show-search
                v-model="form.regionId"
                placeholder="请选择"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option v-for="d in userRegion" :key="d.id">{{ d.name }}</a-select-option>
              </a-select>
              <a-button type="primary" @click="$refs.ReginForm.handleAdd()" v-hasPermi="['system:dept:add']">
                新增
              </a-button>
            </div>
          </a-form-model-item>
          <a-form-model-item label="部门" prop="deptId">
            <div class="form_select">
              <a-tree-select
                v-model="form.deptId"
                style="width: 100%"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="deptOptions"
                placeholder="请选择"
                :replaceFields="replaceFields"
                tree-default-expand-all
              >
              </a-tree-select>
              <a-button type="primary" @click="$refs.deptForm.handleAdd()" v-hasPermi="['system:region:add']">
                新增
              </a-button>
            </div>
          </a-form-model-item>
          <a-form-model-item label="岗位" prop="postIds">
            <div class="form_select">
              <a-select mode="multiple" v-model="form.postIds" placeholder="请选择">
                <a-select-option v-for="(d, index) in postOptions" :key="d.id" :value="d.id">
                  {{ d.postName }}
                </a-select-option>
              </a-select>
              <a-button type="primary" @click="$refs.postForm.handleAdd()" v-hasPermi="['system:dept:add']">
                新增
              </a-button>
            </div>
          </a-form-model-item>
          <!-- <a-form-model-item label="邮箱" prop="email">
          <a-input v-model="form.email" placeholder="请输入" />
        </a-form-model-item> -->
          <!-- <a-form-model-item label="用户名" prop="userName" v-if="form.id == undefined">
            <a-input v-model="form.userName" placeholder="请输入" />
          </a-form-model-item> -->
          <a-form-model-item label="密码" prop="password" v-if="form.id == undefined">
            <a-input-password v-model="form.password" placeholder="未设置密码,默认密码为123456abc" :maxLength="12" />
          </a-form-model-item>
          <a-form-model-item label="性别" prop="sex">
            <a-radio-group v-model="form.sex" button-style="solid">
              <a-radio-button v-for="(d, index) in sexOptions" :key="index" :value="parseInt(d.value)">{{
                d.label
              }}</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <!-- <a-form-model-item label="状态" prop="status">
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button v-for="(d, index) in statusOptions" :key="index" :value="parseInt(d.value)">{{
            d.label
          }}</a-radio-button>
        </a-radio-group>
      </a-form-model-item> -->
          <a-form-model-item label="角色" prop="roleIds" v-if="!role">
            <div class="form_select">
              <a-select mode="multiple" v-model="form.roleIds" placeholder="请选择" @change="handleRoleChange">
                <a-select-option v-for="(d, index) in roleOptions" :key="index" :value="d.id">
                  {{ d.roleName }}
                </a-select-option>
              </a-select>
              <a-button type="primary" @click="$refs.roleForm.handleAdd()" v-hasPermi="['system:dept:add']">
                新增
              </a-button>
            </div>
          </a-form-model-item>
          <a-form-model-item label="备注" prop="remark">
            <a-input v-model="form.remark" placeholder="请输入" type="textarea" allow-clear />
          </a-form-model-item>
        </template>
      </template>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ !isFage ? '保存' : '绑定' }}
          </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>

    <!-- 部门 -->
    <deptForm
      ref="deptForm"
      :deptOptions="deptOption"
      @ok="getDeptTree"
      :statusOptions="dict.type['sys_enable_disable']"
    >
    </deptForm>
    <!-- 岗位 -->
    <postForm
      ref="postForm"
      @ok="getuserInfo"
      :deptOptions="deptOption"
      :statusOptions="dict.type['sys_enable_disable']"
    >
    </postForm>
    <ReginForm ref="ReginForm" @ok="getQu"></ReginForm>
    <roleForm ref="roleForm" @ok="getuserInfo" :statusOptions="dict.type['sys_enable_disable']"></roleForm>
  </a-drawer>
</template>
<script>
import { getUser, addUser, updateUser, deptTreeSelect, checkPhone, userBd } from '@/api/system/user'
import { pageRole } from '@/api/system/role'
// import deptForm from '../../dept/modules/modules/CreateForm'
import deptForm from '../../dept/modules/CreateForm.vue'
import postForm from '../../post/modules/CreateForm.vue'
// import roleForm from '../../../pressure/roles/modules/CreateForm.vue'
import roleForm from '../../role/modules/CreateForm.vue'
import { regionList } from '@/api/pressure/region'
import ReginForm from '../../../pressure/region/modules/CreateForm.vue'
export default {
  name: 'CreateForm',
  dicts: ['sys_enable_disable'],
  props: {
    deptOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    userRegion: {
      type: Array,
    },
    role: {
      type: String,
    },
    sexOptions: {
      type: Array,
      required: true,
    },
  },
  components: { deptForm, postForm, roleForm, ReginForm },
  data() {
    const regPass = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/
    const validatePass = (rule, value, callback) => {
      console.log(value, 'valuevalue')
      if (!value) {
        callback()
      } else if (!regPass.test(value)) {
        callback(new Error('请输入密码6-12位(数字+字母)'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      isShow: false,
      deptOption: [
        {
          id: 0,
          label: '',
          children: [],
        },
      ],
      userId: '',
      replaceFields: { children: 'children', title: 'label', key: 'id', value: 'id' },
      // 岗位选项
      postOptions: [],
      // 角色选项
      roleOptions: [],
      // 默认密码
      initPassword: undefined,
      formTitle: '',
      rolesId: [],
      isFage: false,
      isEdit: false,
      // 表单参数
      form: {
        id: undefined,
        deptId: 0,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phoneNumber: undefined,
        email: undefined,
        sex: 0,
        status: 1,
        remark: undefined,
        postIds: [],
        roleIds: [],
        cardImgs: [],
        avatar: undefined,
        birthday: undefined,
      },
      open: false,
      showLoading: false,
      // userRegion: [],
      rules: {
        roleIds: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        // regionId: [{ required: true, message: '请选择区域', trigger: 'blur' }],
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        nickName: [{ required: true, message: '请输入用户姓名', trigger: 'blur' }],
        // deptId: [{ required: true, message: '部门不能为空', trigger: 'change' }],
        password: [
          // { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: validatePass, trigger: 'change' },
        ],
        // email: [
        //   { required: true, message: '邮箱不能为空', trigger: 'blur' },
        //   {
        //     type: 'email',
        //     message: '请正确填写邮箱地址',
        //     trigger: ['blur', 'change'],
        //   },
        // ],
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请正确填写手机号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  filters: {},
  created() {
    // this.deptOption = this.deptOptions
    console.log(this.deptOptions, 'this.deptOptions')
    console.log(this.infoUser, 'infoUser')

    // this.getConfigKey('sys.user.initPassword').then((response) => {
    //   this.initPassword = response.msg
    // })
    if (this.role) {
      pageRole({ roleKey: this.role }).then((res) => {
        console.log(res, '测试角色细心')
        if (res.data.records.length) {
          this.rolesId = [res.data.records[0].id]
        }
      })
    }
    console.log(this.role, '测试角色====')
    // if (this.userType === 1 || this.userType === 0) {
    //   this.getQu()
    // }
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() {},
      })
    },
    // 查询区域
    getQu() {
      regionList().then((res) => {
        console.log(res, '的点点滴滴')
        this.userRegion = res.data
      })
    },
    // 点击角色发生变化
    handleRoleChange(e) {},
    // 点击添加区域
    handleQu() {
      this.childrenDrawer = true
      this.$nextTick(() => {
        this.$refs.ReginForm.handleAdd()
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 查询部门下拉树结构 */
    getDeptTree() {
      deptTreeSelect().then((response) => {
        this.deptOptions = response.data
      })
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        deptId: undefined,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phoneNumber: undefined,
        email: undefined,
        sex: 0,
        status: 1,
        remark: undefined,
        postIds: [],
        roleIds: [],
        cardImgs: [],
        avatar: undefined,
        birthday: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.isEdit = false
      this.reset()
      this.$emit('select-tree')
      this.open = true
      if (this.role == 'YSY00') {
        this.formTitle = '新增验收员'
      } else if (this.role == 'SG00') {
        this.formTitle = '新增水工'
      } else {
        this.formTitle = '新增用户'
      }
      this.form.password = this.initPassword
      this.isFage = false
      this.isShow = false
      this.getuserInfo()
    },
    // 查询用户信息
    getuserInfo() {
      getUser(this.userId ? this.userId : '').then((response) => {
        console.log(response, 'responseresponseresponse=======')
        this.postOptions = response.data.posts
        this.roleOptions = response.data.roles
      })
    },
    // 手机号发生变化
    handleChangePhone() {
      // if (!this.role) return
      const phoneNumber = this.form.phoneNumber
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if (phoneNumber && phoneNumber.length === 11) {
        if (!reg.test(phoneNumber)) return this.$message.error('请输入正确的手机号')
        checkPhone({ phoneNumber: this.form.phoneNumber }).then((res) => {
          console.log(res, '的点点滴滴')
          if (Number(res.data.unique) === 1) {
            const phone = this.form.phoneNumber
            this.form = res.data
            this.form.phoneNumber = phone
            this.isShow = true
            this.isFage = true
          } else {
            // this.get
            this.isShow = true
            this.isFage = false
            this.reset()
            this.form.phoneNumber = phoneNumber
            this.$forceUpdate()
          }
          //   if(res.unique==1){
          // 	this.show=false
          // 	this.id=res.id
          // }else{
          // 	this.show=true
          // }
        })
      }
    },
    // 选择生日
    handleChange(date, dateString) {
      console.log(date, dateString, '的点点滴滴')
      this.form.birthday = dateString
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.$emit('select-tree')
      const userId = row ? row.id : ids
      // this.formTitle = '修改用户'
      if (this.role == 'YSY00') {
        this.formTitle = '修改验收员'
      } else if (this.role == 'SG00') {
        this.formTitle = '修改水工'
      } else {
        this.formTitle = '修改用户'
      }
      this.isEdit = true
      this.isFage = false
      this.open = true
      this.userId = this.userId
      getUser(userId).then((response) => {
        console.log(response, 'responseresponseresponse')
        if (response.data.deptIds && response.data.deptIds.length) {
          response.data.data.deptId = response.data.deptIds[0]
        }
        response.data.data.roleIds = response.data.roleIds
        response.data.data.postIds = response.data.postIds
        if (response.data.data.regionId == 0 || !response.data.data.regionId) {
          response.data.data.regionId = undefined
        }
        this.form = response.data.data
        console.log(this.form, '顶顶顶顶')

        this.postOptions = response.data.posts
        this.roleOptions = response.data.roles
        console.log(this.roleOptions, 'this.roleOptionsthis.roleOptions')
        // this.form.postIds = response.data.postIds
        // this.form.roleIds = response.data.roleIds
        this.open = true
        // this.formTitle = '修改用户'
        this.form.password = undefined
      })
      if (this.role) {
        // this.form
      }
      // this.isFage=true
      this.isShow = true
      // console.log(this.isShow,'this.isShow.isFage');
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.isFage, 'isFageisFage')
      const that = this
      this.$refs.form.validate((valid, object) => {
        console.log(object, 'objectobject')
        if (valid) {
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.isFage) {
            // if (this.form.roleIds && this.form.roleIds.length) {
            //   if (this.form.roleIds.indexOf(this.rolesId[0]) !== -1) {
            //     this.submitLoading = false
            //     return this.$message.error('当前账号已经在您账号下')
            //   }
            // } else {
            //   console.log(this.form.roleIds, 'this.form.roleIds')
            //   console.log(this.rolesId, 'this.rolesIdthis.rolesId')
            //   this.form.roleIds = this.rolesId
            // }
            if (this.form.roleIds.indexOf(this.rolesId[0]) !== -1) {
              this.submitLoading = false
              return this.$message.error('当前账号已经在您账号下')
            }
            const roleIds = this.form.roleIds.concat(this.rolesId)
            this.form.roleIds = roleIds
            userBd(that.form)
              .then((respon) => {
                that.$message.success('绑定成功', 3)
                that.open = false
                that.$emit('ok')
              })
              .finally(() => {
                that.submitLoading = false
              })
          } else {
            if (this.role) {
              this.form.roleIds = this.rolesId
            }
            if (this.form.deptId) {
              this.form.deptIds = [this.form.deptId]
            }
            if (this.form.id !== undefined) {
              updateUser(this.form)
                .then((response) => {
                  this.$message.success('修改成功', 3)
                  this.open = false
                  this.$emit('ok')
                })
                .finally(() => {
                  this.submitLoading = false
                })
            } else {
              this.form.userName = this.form.phoneNumber
              if (!this.form.password) {
                this.form.password = '123456abc'
              }
              if (this.form.deptId) {
                this.form.deptIds = [this.form.deptId]
              }
              addUser(this.form)
                .then((response) => {
                  this.$message.success('新增成功', 3)
                  this.open = false
                  this.$emit('ok')
                })
                .finally(() => {
                  this.submitLoading = false
                })
            }
          }
          // checkPhone({ phoneNumber: this.form.phoneNumber }).then((res) => {
          //   console.log(res, '的点点滴滴')
          //   res = res.data
          //   if (Number(res.unique) === 1) {
          //     that.form.id = res.id
          //   } else {

          //   }
          // })
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          console.log(messages, 'messages')
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.form_select {
  display: flex;
  align-items: center;

  .ant-select {
    width: 300px;
    margin-right: 20px;
  }
}
</style>
